<div style="height: 100%;">
    <div id="map" #gmap></div>
</div>
